module.exports = __webpack_public_path__ + "static/media/tour_close_icon.68e69acf.svg";